// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Lexend:wght@400;600;700;800;900&family=Inter:wght@300;400;500;600;700&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Material+Symbols+Outlined:wght@200..700);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --bg: #f6f7fb;
  --text: #0b1220;
  --muted: #5b6b83;
  --border: #d8e0eb;
  --card: #ffffff;
  --blue: #0f49bd;
  --blue2: #1a60ff;
  --shadow: 0 14px 38px rgba(15, 23, 42, 0.08);
}

.jp-page {
  --jp-type-heading: clamp(2rem, 2.6vw, 2.5rem);
  --jp-type-subheading: 1.2rem;
  --jp-type-card-heading: 1.2rem;
  --jp-type-body: 1.05rem;
  --jp-type-label: 0.9rem;
  --jp-type-cta: 1rem;
  background: var(--bg);
  color: var(--text);
  font-family: Inter, system-ui, -apple-system, Segoe UI, Roboto, Arial, sans-serif;
  padding: 6.2rem 0 4rem;
}

.jp-container {
  max-width: 980px;
  margin: 0 auto;
  padding: 0 18px;
}

/* Tabs */
.jp-tabs {
  display: flex;
  gap: 24px;
  border-bottom: 1px solid var(--border);
  padding-bottom: 14px;
  margin: -18px 0 8px;
}

.jp-tab {
  text-decoration: none;
  color: #3d5a86;
  font-weight: 600;
  padding: 6px 6px 12px;
  position: relative;
  font-size: var(--jp-type-label);
}

.jp-tab.is-active {
  color: var(--blue);
}

.jp-tab.is-active::after {
  content: "";
  position: absolute;
  left: 0;
  right: 0;
  bottom: -15px;
  height: 3px;
  border-radius: 999px;
  background: var(--blue);
}

/* Hero */
.jp-hero {
  position: relative;
  border-radius: 18px;
  overflow: hidden;
  min-height: 320px;
  box-shadow: 0 28px 65px rgba(15, 23, 42, 0.25);
  display: grid;
  grid-template-columns: minmax(280px, 1fr) minmax(0, 1fr);
  background: transparent;
}

.jp-hero__image {
  background-size: cover;
  background-position: center;
  border-radius: 18px 0 0 18px;
}

.jp-hero__content {
  position: relative;
  z-index: 2;
  padding: 44px 40px;
  max-width: 620px;
  background: linear-gradient(180deg, #030615, #050b1a 90%);
  border-radius: 0 18px 18px 0;
  display: flex;
  flex-direction: column;
  gap: 0.6rem;
}

.jp-badge {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  font-size: var(--jp-type-label);
  letter-spacing: 0.08em;
  color: rgba(255, 255, 255, 0.9);
  background: rgba(255, 255, 255, 0.12);
  border: 1px solid rgba(255, 255, 255, 0.2);
  padding: 6px 12px;
  border-radius: 999px;
  font-weight: 700;
}

.jp-hero__title {
  margin: 14px 0 10px;
  font-family: Lexend, Inter, system-ui, sans-serif;
  font-weight: 900;
  color: #fff;
  line-height: 1.05;
  font-size: clamp(34px, 4.2vw, 50px);
  text-shadow: 0 8px 22px rgba(0, 0, 0, 0.35);
}

.jp-hero__subtitle {
  margin: 0 0 18px;
  color: rgba(255, 255, 255, 0.86);
  line-height: 1.55;
  max-width: 520px;
  font-size: var(--jp-type-body);
}

.jp-hero__actions {
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
}

/* Buttons */
.jp-btn {
  border: none;
  outline: none;
  cursor: pointer;
  border-radius: 10px;
  padding: 12px 16px;
  font-weight: 700;
  font-size: var(--jp-type-cta);
  transition: transform 0.15s ease, filter 0.15s ease;
  display: inline-flex;
  align-items: center;
  gap: 8px;
}

.jp-btn:hover {
  transform: translateY(-1px);
  color: #f59e0b;
  filter: brightness(1.02);
}

.jp-btn--primary {
  background: linear-gradient(180deg, var(--blue2), var(--blue));
  color: #fff;
  box-shadow: 0 10px 20px rgba(15, 73, 189, 0.28);
}

.jp-btn--secondary {
  background: rgba(255, 255, 255, 0.12);
  color: #fff;
  border: 1px solid rgba(255, 255, 255, 0.28);
}

.jp-btn--ghost {
  background: transparent;
  color: #fff;
  border: 1px solid rgba(255, 255, 255, 0.28);
}

/* Sections */
.jp-section {
  margin-top: 26px;
}

.jp-section--spaced {
  margin-top: 34px;
}

.jp-section__title {
  margin: 0 0 14px;
  font-size: var(--jp-type-heading);
  font-weight: 800;
  color: #0b1220;
}

.jp-section__subtitle {
  margin: 6px 0 0;
  color: var(--muted);
  font-size: var(--jp-type-subheading);
}

.jp-section__head {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  gap: 16px;
  flex-wrap: wrap;
}

.jp-link {
  border: none;
  background: transparent;
  color: var(--blue);
  font-weight: 700;
  cursor: pointer;
  padding: 8px 0;
}

/* Grids */
.jp-grid {
  display: grid;
  gap: 18px;
}

.jp-grid--3 {
  grid-template-columns: repeat(3, minmax(0, 1fr));
}

/* Highlight cards */
.jp-card {
  background: var(--card);
  border: 1px solid var(--border);
  border-radius: 12px;
  padding: 18px;
  box-shadow: 0 10px 22px rgba(15, 23, 42, 0.04);
}

.jp-card__icon {
  width: 40px;
  height: 40px;
  border-radius: 999px;
  display: grid;
  place-items: center;
  background: #eef3ff;
  color: var(--blue);
  margin-bottom: 10px;
}

.jp-card__title {
  margin: 0 0 6px;
  font-size: var(--jp-type-card-heading);
  font-weight: 800;
}

.jp-card__text {
  margin: 0;
  color: var(--muted);
  font-size: var(--jp-type-body);
  line-height: 1.5;
}

/* Accordion */
.jp-accordion {
  margin-top: 14px;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.jp-accordion__item {
  background: var(--card);
  border: 1px solid var(--border);
  border-radius: 10px;
  overflow: hidden;
}

.jp-accordion__summary {
  list-style: none;
  cursor: pointer;
  padding: 14px 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-weight: 800;
  font-size: var(--jp-type-body);
}

.jp-accordion__summary::-webkit-details-marker {
  display: none;
}

.jp-accordion__left {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  color: #0b1220;
}

.jp-accordion__chev {
  color: #2b3a55;
  transition: transform 0.18s ease;
}

details[open] .jp-accordion__chev {
  transform: rotate(180deg);
}

.jp-accordion__body {
  padding: 0 16px 14px;
  color: var(--muted);
  font-size: var(--jp-type-body);
}

/* Note bar */
.jp-note {
  margin-top: 14px;
  background: #eef6ff;
  border: 1px solid #d6e8ff;
  border-radius: 10px;
  padding: 12px 14px;
  display: flex;
  gap: 10px;
  align-items: flex-start;
  color: #1a4dbd;
  font-size: var(--jp-type-body);
}

/* Advantage cards */
.jp-adv {
  background: var(--card);
  border: 1px solid var(--border);
  border-radius: 12px;
  padding: 16px;
  display: flex;
  gap: 12px;
  box-shadow: 0 10px 22px rgba(15, 23, 42, 0.04);
}

.jp-adv__icon {
  width: 40px;
  height: 40px;
  border-radius: 10px;
  display: grid;
  place-items: center;
  background: #eef3ff;
  color: var(--blue);
}

.jp-adv__title {
  margin: 0;
  font-size: var(--jp-type-card-heading);
  font-weight: 800;
}

.jp-adv__text {
  margin: 6px 0 0;
  font-size: var(--jp-type-body);
  color: var(--muted);
  line-height: 1.45;
}

/* CTA */
.jp-cta {
  margin-top: 34px;
  border-radius: 16px;
  padding: 22px 24px;
  color: #fff;
  background: #370b3b;
  box-shadow: 0 26px 60px rgba(55, 11, 59, 0.45);
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
  flex-wrap: wrap;
}

.jp-page.jp-page--jee .jp-cta {
  background: #370b3b;
  box-shadow: 0 26px 60px rgba(55, 11, 59, 0.45);
}

.jp-cta__title {
  margin: 0 0 6px;
  font-family: Lexend, Inter, system-ui, sans-serif;
  font-weight: 900;
  letter-spacing: 0.01em;
  font-size: var(--jp-type-heading);
  color: #ffffff;
}

.jp-cta__text {
  margin: 0;
  color: rgba(255, 255, 255, 0.95);
  font-size: var(--jp-type-body);
  max-width: 420px;
  line-height: 1.45;
}

.jp-cta__actions {
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
}

/* Responsive */
@media (max-width: 920px) {
  .jp-grid--3 {
    grid-template-columns: 1fr;
  }
  .jp-hero__content {
    padding: 34px 22px;
  }
}

@media (max-width: 520px) {
  .jp-tabs {
    gap: 14px;
  }
}

/* ================================
   JP HERO LAYOUT FIX (JEE = image LEFT)
   ================================ */

.jp-hero {
  position: relative;
  overflow: hidden;
  border-radius: 22px;
  min-height: 360px;
  display: flex;
  align-items: stretch;
  background: #370b3b;
  box-shadow: 0 26px 60px rgba(55, 11, 59, 0.35);
}

.jp-hero__image {
  order: 1;
  flex: 0 0 58%;
  position: relative;
  min-height: 280px;
  height: auto;
  background-size: cover;
  background-position: center;
  width: auto;
  margin: 18px;
  border-radius: 18px;
}

.jp-hero__content {
  order: 2;
  flex: 1;
  padding: 42px 42px 42px 10px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 14px;
  color: #fff;
}

.jp-badge {
  width: fit-content;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  font-size: var(--jp-type-label);
  font-weight: 800;
  letter-spacing: 0.08em;
  padding: 8px 12px;
  border-radius: 999px;
  color: #0f49bd;
  background: rgba(255, 255, 255, 0.92);
}

.jp-hero__title {
  margin: 0;
  font-family: Lexend, Inter, system-ui, sans-serif;
  font-weight: 900;
  letter-spacing: -0.02em;
  font-size: clamp(36px, 4vw, 56px);
  line-height: 1.05;
}

.jp-hero__subtitle {
  margin: 0;
  max-width: 520px;
  color: rgba(255, 255, 255, 0.9);
  line-height: 1.55;
  font-size: var(--jp-type-body);
}

.jp-hero__actions {
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
  margin-top: 10px;
}

@media (max-width: 900px) {
  .jp-hero {
    flex-direction: column;
    min-height: auto;
  }

  .jp-hero__image {
    flex: none;
    height: 300px;
    margin: 16px;
  }

  .jp-hero__content {
    padding: 10px 18px 22px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/frontend/pages/Courses/jee-main-advanced.css"],"names":[],"mappings":"AAGA;EACE,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,4CAA4C;AAC9C;;AAEA;EACE,6CAA6C;EAC7C,4BAA4B;EAC5B,8BAA8B;EAC9B,uBAAuB;EACvB,uBAAuB;EACvB,mBAAmB;EACnB,qBAAqB;EACrB,kBAAkB;EAClB,iFAAiF;EACjF,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA,SAAS;AACT;EACE,aAAa;EACb,SAAS;EACT,sCAAsC;EACtC,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,gBAAgB;EAChB,qBAAqB;EACrB,kBAAkB;EAClB,+BAA+B;AACjC;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,aAAa;EACb,WAAW;EACX,oBAAoB;EACpB,uBAAuB;AACzB;;AAEA,SAAS;AACT;EACE,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,8CAA8C;EAC9C,aAAa;EACb,wDAAwD;EACxD,uBAAuB;AACzB;;AAEA;EACE,sBAAsB;EACtB,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,kBAAkB;EAClB,gBAAgB;EAChB,yDAAyD;EACzD,4BAA4B;EAC5B,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,+BAA+B;EAC/B,sBAAsB;EACtB,+BAA+B;EAC/B,qCAAqC;EACrC,0CAA0C;EAC1C,iBAAiB;EACjB,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,iDAAiD;EACjD,gBAAgB;EAChB,WAAW;EACX,iBAAiB;EACjB,mCAAmC;EACnC,2CAA2C;AAC7C;;AAEA;EACE,gBAAgB;EAChB,gCAAgC;EAChC,iBAAiB;EACjB,gBAAgB;EAChB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;AACjB;;AAEA,YAAY;AACZ;EACE,YAAY;EACZ,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,6BAA6B;EAC7B,mDAAmD;EACnD,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,2BAA2B;EAC3B,cAAc;EACd,wBAAwB;AAC1B;;AAEA;EACE,8DAA8D;EAC9D,WAAW;EACX,+CAA+C;AACjD;;AAEA;EACE,qCAAqC;EACrC,WAAW;EACX,2CAA2C;AAC7C;;AAEA;EACE,uBAAuB;EACvB,WAAW;EACX,2CAA2C;AAC7C;;AAEA,aAAa;AACb;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,iCAAiC;EACjC,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,qBAAqB;EACrB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA,UAAU;AACV;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,gDAAgD;AAClD;;AAEA,oBAAoB;AACpB;EACE,uBAAuB;EACvB,+BAA+B;EAC/B,mBAAmB;EACnB,aAAa;EACb,8CAA8C;AAChD;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,sCAAsC;EACtC,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,mBAAmB;EACnB,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA,cAAc;AACd;EACE,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,uBAAuB;EACvB,+BAA+B;EAC/B,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,gBAAgB;EAChB,8BAA8B;AAChC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA,aAAa;AACb;EACE,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,SAAS;EACT,uBAAuB;EACvB,cAAc;EACd,8BAA8B;AAChC;;AAEA,oBAAoB;AACpB;EACE,uBAAuB;EACvB,+BAA+B;EAC/B,mBAAmB;EACnB,aAAa;EACb,aAAa;EACb,SAAS;EACT,8CAA8C;AAChD;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,sCAAsC;EACtC,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,8BAA8B;EAC9B,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA,QAAQ;AACR;EACE,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;EACX,mBAAmB;EACnB,8CAA8C;EAC9C,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,8CAA8C;AAChD;;AAEA;EACE,eAAe;EACf,iDAAiD;EACjD,gBAAgB;EAChB,sBAAsB;EACtB,iCAAiC;EACjC,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,gCAAgC;EAChC,8BAA8B;EAC9B,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;AACjB;;AAEA,eAAe;AACf;EACE;IACE,0BAA0B;EAC5B;EACA;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,SAAS;EACX;AACF;;AAEA;;qCAEqC;;AAErC;EACE,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;EACjB,aAAa;EACb,oBAAoB;EACpB,mBAAmB;EACnB,8CAA8C;AAChD;;AAEA;EACE,QAAQ;EACR,aAAa;EACb,kBAAkB;EAClB,iBAAiB;EACjB,YAAY;EACZ,sBAAsB;EACtB,2BAA2B;EAC3B,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,QAAQ;EACR,OAAO;EACP,4BAA4B;EAC5B,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,SAAS;EACT,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,+BAA+B;EAC/B,gBAAgB;EAChB,sBAAsB;EACtB,iBAAiB;EACjB,oBAAoB;EACpB,cAAc;EACd,qCAAqC;AACvC;;AAEA;EACE,SAAS;EACT,iDAAiD;EACjD,gBAAgB;EAChB,uBAAuB;EACvB,iCAAiC;EACjC,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,gBAAgB;EAChB,+BAA+B;EAC/B,iBAAiB;EACjB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE;IACE,sBAAsB;IACtB,gBAAgB;EAClB;;EAEA;IACE,UAAU;IACV,aAAa;IACb,YAAY;EACd;;EAEA;IACE,uBAAuB;EACzB;AACF","sourcesContent":["@import url(\"https://fonts.googleapis.com/css2?family=Lexend:wght@400;600;700;800;900&family=Inter:wght@300;400;500;600;700&display=swap\");\r\n@import url(\"https://fonts.googleapis.com/css2?family=Material+Symbols+Outlined:wght@200..700\");\r\n\r\n:root {\r\n  --bg: #f6f7fb;\r\n  --text: #0b1220;\r\n  --muted: #5b6b83;\r\n  --border: #d8e0eb;\r\n  --card: #ffffff;\r\n  --blue: #0f49bd;\r\n  --blue2: #1a60ff;\r\n  --shadow: 0 14px 38px rgba(15, 23, 42, 0.08);\r\n}\r\n\r\n.jp-page {\r\n  --jp-type-heading: clamp(2rem, 2.6vw, 2.5rem);\r\n  --jp-type-subheading: 1.2rem;\r\n  --jp-type-card-heading: 1.2rem;\r\n  --jp-type-body: 1.05rem;\r\n  --jp-type-label: 0.9rem;\r\n  --jp-type-cta: 1rem;\r\n  background: var(--bg);\r\n  color: var(--text);\r\n  font-family: Inter, system-ui, -apple-system, Segoe UI, Roboto, Arial, sans-serif;\r\n  padding: 6.2rem 0 4rem;\r\n}\r\n\r\n.jp-container {\r\n  max-width: 980px;\r\n  margin: 0 auto;\r\n  padding: 0 18px;\r\n}\r\n\r\n/* Tabs */\r\n.jp-tabs {\r\n  display: flex;\r\n  gap: 24px;\r\n  border-bottom: 1px solid var(--border);\r\n  padding-bottom: 14px;\r\n  margin: -18px 0 8px;\r\n}\r\n\r\n.jp-tab {\r\n  text-decoration: none;\r\n  color: #3d5a86;\r\n  font-weight: 600;\r\n  padding: 6px 6px 12px;\r\n  position: relative;\r\n  font-size: var(--jp-type-label);\r\n}\r\n\r\n.jp-tab.is-active {\r\n  color: var(--blue);\r\n}\r\n\r\n.jp-tab.is-active::after {\r\n  content: \"\";\r\n  position: absolute;\r\n  left: 0;\r\n  right: 0;\r\n  bottom: -15px;\r\n  height: 3px;\r\n  border-radius: 999px;\r\n  background: var(--blue);\r\n}\r\n\r\n/* Hero */\r\n.jp-hero {\r\n  position: relative;\r\n  border-radius: 18px;\r\n  overflow: hidden;\r\n  min-height: 320px;\r\n  box-shadow: 0 28px 65px rgba(15, 23, 42, 0.25);\r\n  display: grid;\r\n  grid-template-columns: minmax(280px, 1fr) minmax(0, 1fr);\r\n  background: transparent;\r\n}\r\n\r\n.jp-hero__image {\r\n  background-size: cover;\r\n  background-position: center;\r\n  border-radius: 18px 0 0 18px;\r\n}\r\n\r\n.jp-hero__content {\r\n  position: relative;\r\n  z-index: 2;\r\n  padding: 44px 40px;\r\n  max-width: 620px;\r\n  background: linear-gradient(180deg, #030615, #050b1a 90%);\r\n  border-radius: 0 18px 18px 0;\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 0.6rem;\r\n}\r\n\r\n.jp-badge {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n  font-size: var(--jp-type-label);\r\n  letter-spacing: 0.08em;\r\n  color: rgba(255, 255, 255, 0.9);\r\n  background: rgba(255, 255, 255, 0.12);\r\n  border: 1px solid rgba(255, 255, 255, 0.2);\r\n  padding: 6px 12px;\r\n  border-radius: 999px;\r\n  font-weight: 700;\r\n}\r\n\r\n.jp-hero__title {\r\n  margin: 14px 0 10px;\r\n  font-family: Lexend, Inter, system-ui, sans-serif;\r\n  font-weight: 900;\r\n  color: #fff;\r\n  line-height: 1.05;\r\n  font-size: clamp(34px, 4.2vw, 50px);\r\n  text-shadow: 0 8px 22px rgba(0, 0, 0, 0.35);\r\n}\r\n\r\n.jp-hero__subtitle {\r\n  margin: 0 0 18px;\r\n  color: rgba(255, 255, 255, 0.86);\r\n  line-height: 1.55;\r\n  max-width: 520px;\r\n  font-size: var(--jp-type-body);\r\n}\r\n\r\n.jp-hero__actions {\r\n  display: flex;\r\n  gap: 12px;\r\n  flex-wrap: wrap;\r\n}\r\n\r\n/* Buttons */\r\n.jp-btn {\r\n  border: none;\r\n  outline: none;\r\n  cursor: pointer;\r\n  border-radius: 10px;\r\n  padding: 12px 16px;\r\n  font-weight: 700;\r\n  font-size: var(--jp-type-cta);\r\n  transition: transform 0.15s ease, filter 0.15s ease;\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n}\r\n\r\n.jp-btn:hover {\r\n  transform: translateY(-1px);\r\n  color: #f59e0b;\r\n  filter: brightness(1.02);\r\n}\r\n\r\n.jp-btn--primary {\r\n  background: linear-gradient(180deg, var(--blue2), var(--blue));\r\n  color: #fff;\r\n  box-shadow: 0 10px 20px rgba(15, 73, 189, 0.28);\r\n}\r\n\r\n.jp-btn--secondary {\r\n  background: rgba(255, 255, 255, 0.12);\r\n  color: #fff;\r\n  border: 1px solid rgba(255, 255, 255, 0.28);\r\n}\r\n\r\n.jp-btn--ghost {\r\n  background: transparent;\r\n  color: #fff;\r\n  border: 1px solid rgba(255, 255, 255, 0.28);\r\n}\r\n\r\n/* Sections */\r\n.jp-section {\r\n  margin-top: 26px;\r\n}\r\n\r\n.jp-section--spaced {\r\n  margin-top: 34px;\r\n}\r\n\r\n.jp-section__title {\r\n  margin: 0 0 14px;\r\n  font-size: var(--jp-type-heading);\r\n  font-weight: 800;\r\n  color: #0b1220;\r\n}\r\n\r\n.jp-section__subtitle {\r\n  margin: 6px 0 0;\r\n  color: var(--muted);\r\n  font-size: var(--jp-type-subheading);\r\n}\r\n\r\n.jp-section__head {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: flex-end;\r\n  gap: 16px;\r\n  flex-wrap: wrap;\r\n}\r\n\r\n.jp-link {\r\n  border: none;\r\n  background: transparent;\r\n  color: var(--blue);\r\n  font-weight: 700;\r\n  cursor: pointer;\r\n  padding: 8px 0;\r\n}\r\n\r\n/* Grids */\r\n.jp-grid {\r\n  display: grid;\r\n  gap: 18px;\r\n}\r\n\r\n.jp-grid--3 {\r\n  grid-template-columns: repeat(3, minmax(0, 1fr));\r\n}\r\n\r\n/* Highlight cards */\r\n.jp-card {\r\n  background: var(--card);\r\n  border: 1px solid var(--border);\r\n  border-radius: 12px;\r\n  padding: 18px;\r\n  box-shadow: 0 10px 22px rgba(15, 23, 42, 0.04);\r\n}\r\n\r\n.jp-card__icon {\r\n  width: 40px;\r\n  height: 40px;\r\n  border-radius: 999px;\r\n  display: grid;\r\n  place-items: center;\r\n  background: #eef3ff;\r\n  color: var(--blue);\r\n  margin-bottom: 10px;\r\n}\r\n\r\n.jp-card__title {\r\n  margin: 0 0 6px;\r\n  font-size: var(--jp-type-card-heading);\r\n  font-weight: 800;\r\n}\r\n\r\n.jp-card__text {\r\n  margin: 0;\r\n  color: var(--muted);\r\n  font-size: var(--jp-type-body);\r\n  line-height: 1.5;\r\n}\r\n\r\n/* Accordion */\r\n.jp-accordion {\r\n  margin-top: 14px;\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 12px;\r\n}\r\n\r\n.jp-accordion__item {\r\n  background: var(--card);\r\n  border: 1px solid var(--border);\r\n  border-radius: 10px;\r\n  overflow: hidden;\r\n}\r\n\r\n.jp-accordion__summary {\r\n  list-style: none;\r\n  cursor: pointer;\r\n  padding: 14px 16px;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  font-weight: 800;\r\n  font-size: var(--jp-type-body);\r\n}\r\n\r\n.jp-accordion__summary::-webkit-details-marker {\r\n  display: none;\r\n}\r\n\r\n.jp-accordion__left {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 10px;\r\n  color: #0b1220;\r\n}\r\n\r\n.jp-accordion__chev {\r\n  color: #2b3a55;\r\n  transition: transform 0.18s ease;\r\n}\r\n\r\ndetails[open] .jp-accordion__chev {\r\n  transform: rotate(180deg);\r\n}\r\n\r\n.jp-accordion__body {\r\n  padding: 0 16px 14px;\r\n  color: var(--muted);\r\n  font-size: var(--jp-type-body);\r\n}\r\n\r\n/* Note bar */\r\n.jp-note {\r\n  margin-top: 14px;\r\n  background: #eef6ff;\r\n  border: 1px solid #d6e8ff;\r\n  border-radius: 10px;\r\n  padding: 12px 14px;\r\n  display: flex;\r\n  gap: 10px;\r\n  align-items: flex-start;\r\n  color: #1a4dbd;\r\n  font-size: var(--jp-type-body);\r\n}\r\n\r\n/* Advantage cards */\r\n.jp-adv {\r\n  background: var(--card);\r\n  border: 1px solid var(--border);\r\n  border-radius: 12px;\r\n  padding: 16px;\r\n  display: flex;\r\n  gap: 12px;\r\n  box-shadow: 0 10px 22px rgba(15, 23, 42, 0.04);\r\n}\r\n\r\n.jp-adv__icon {\r\n  width: 40px;\r\n  height: 40px;\r\n  border-radius: 10px;\r\n  display: grid;\r\n  place-items: center;\r\n  background: #eef3ff;\r\n  color: var(--blue);\r\n}\r\n\r\n.jp-adv__title {\r\n  margin: 0;\r\n  font-size: var(--jp-type-card-heading);\r\n  font-weight: 800;\r\n}\r\n\r\n.jp-adv__text {\r\n  margin: 6px 0 0;\r\n  font-size: var(--jp-type-body);\r\n  color: var(--muted);\r\n  line-height: 1.45;\r\n}\r\n\r\n/* CTA */\r\n.jp-cta {\r\n  margin-top: 34px;\r\n  border-radius: 16px;\r\n  padding: 22px 24px;\r\n  color: #fff;\r\n  background: #370b3b;\r\n  box-shadow: 0 26px 60px rgba(55, 11, 59, 0.45);\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  gap: 16px;\r\n  flex-wrap: wrap;\r\n}\r\n\r\n.jp-page.jp-page--jee .jp-cta {\r\n  background: #370b3b;\r\n  box-shadow: 0 26px 60px rgba(55, 11, 59, 0.45);\r\n}\r\n\r\n.jp-cta__title {\r\n  margin: 0 0 6px;\r\n  font-family: Lexend, Inter, system-ui, sans-serif;\r\n  font-weight: 900;\r\n  letter-spacing: 0.01em;\r\n  font-size: var(--jp-type-heading);\r\n  color: #ffffff;\r\n}\r\n\r\n.jp-cta__text {\r\n  margin: 0;\r\n  color: rgba(255, 255, 255, 0.95);\r\n  font-size: var(--jp-type-body);\r\n  max-width: 420px;\r\n  line-height: 1.45;\r\n}\r\n\r\n.jp-cta__actions {\r\n  display: flex;\r\n  gap: 12px;\r\n  flex-wrap: wrap;\r\n}\r\n\r\n/* Responsive */\r\n@media (max-width: 920px) {\r\n  .jp-grid--3 {\r\n    grid-template-columns: 1fr;\r\n  }\r\n  .jp-hero__content {\r\n    padding: 34px 22px;\r\n  }\r\n}\r\n\r\n@media (max-width: 520px) {\r\n  .jp-tabs {\r\n    gap: 14px;\r\n  }\r\n}\r\n\r\n/* ================================\r\n   JP HERO LAYOUT FIX (JEE = image LEFT)\r\n   ================================ */\r\n\r\n.jp-hero {\r\n  position: relative;\r\n  overflow: hidden;\r\n  border-radius: 22px;\r\n  min-height: 360px;\r\n  display: flex;\r\n  align-items: stretch;\r\n  background: #370b3b;\r\n  box-shadow: 0 26px 60px rgba(55, 11, 59, 0.35);\r\n}\r\n\r\n.jp-hero__image {\r\n  order: 1;\r\n  flex: 0 0 58%;\r\n  position: relative;\r\n  min-height: 280px;\r\n  height: auto;\r\n  background-size: cover;\r\n  background-position: center;\r\n  width: auto;\r\n  margin: 18px;\r\n  border-radius: 18px;\r\n}\r\n\r\n.jp-hero__content {\r\n  order: 2;\r\n  flex: 1;\r\n  padding: 42px 42px 42px 10px;\r\n  display: flex;\r\n  flex-direction: column;\r\n  justify-content: center;\r\n  gap: 14px;\r\n  color: #fff;\r\n}\r\n\r\n.jp-badge {\r\n  width: fit-content;\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n  font-size: var(--jp-type-label);\r\n  font-weight: 800;\r\n  letter-spacing: 0.08em;\r\n  padding: 8px 12px;\r\n  border-radius: 999px;\r\n  color: #0f49bd;\r\n  background: rgba(255, 255, 255, 0.92);\r\n}\r\n\r\n.jp-hero__title {\r\n  margin: 0;\r\n  font-family: Lexend, Inter, system-ui, sans-serif;\r\n  font-weight: 900;\r\n  letter-spacing: -0.02em;\r\n  font-size: clamp(36px, 4vw, 56px);\r\n  line-height: 1.05;\r\n}\r\n\r\n.jp-hero__subtitle {\r\n  margin: 0;\r\n  max-width: 520px;\r\n  color: rgba(255, 255, 255, 0.9);\r\n  line-height: 1.55;\r\n  font-size: var(--jp-type-body);\r\n}\r\n\r\n.jp-hero__actions {\r\n  display: flex;\r\n  gap: 12px;\r\n  flex-wrap: wrap;\r\n  margin-top: 10px;\r\n}\r\n\r\n@media (max-width: 900px) {\r\n  .jp-hero {\r\n    flex-direction: column;\r\n    min-height: auto;\r\n  }\r\n\r\n  .jp-hero__image {\r\n    flex: none;\r\n    height: 300px;\r\n    margin: 16px;\r\n  }\r\n\r\n  .jp-hero__content {\r\n    padding: 10px 18px 22px;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
